let currentSearchValue = ''; // Lưu từ khóa tìm kiếm hiện tại

const filterPlate = () => {
  if ($(".drawer-filter").length) {

    chooseNumber();
    showMoreProvince();
    searchProvince();
    chooseProvince();
    clearProvince();
    suggestionPrice();
    resetFilter();
    submitFilter();
  }
}

const submitFilter = () => {
  $('.btn-filter-submit').click(function () {
    const minPrice = $('input[name="minPrice"]').val();
    const maxPrice = $('input[name="maxPrice"]').val();
    const province = $('.g-option.active').map(function () {
      return $(this).data('value');
    }).get().join(',');
    const excludedNumbers = $('.form-number .section-item:not(.active)').map(function () {
      return $(this).data('value');
    }).get().join(',');

    const params = {
      minPrice, maxPrice,
      excludedNumbers, province
    }
    const searchParams = new URLSearchParams(window.location.search);

    for(let key of ['province', 'excludedNumbers', 'minPrice', 'maxPrice']) {
      if (searchParams.has(key)) {
        if(params[key]) searchParams.set(key, params[key]);
        else searchParams.delete(key);
      }
      else {
        if(params[key]) searchParams.append(key, params[key]);
      }
    }

    window.location.href = `/tim-kiem?${searchParams.toString()}`;
  })
}

const resetFilter = () => {
  $('.btn-reset').click(function () {
    $('.form-number .section-item').addClass('active');
    $('.suggestion-price .suggestion-price-item').removeClass('active');
    $('.g-option').removeClass('active');
    $('input[name="minPrice"]').val('');
    $('input[name="maxPrice"]').val('');
    $('.form-city .g-input input').val('');
    $('.form-city .g-input input').trigger('input');
    window.location.href = `/tim-kiem`;
  })
}

const chooseNumber = () => {
  $('.form-number .section-item').click(function () {
    $(this).toggleClass('active');

    const numbers = $('.form-number .section-item:not(.active)');
    const numbersValue = numbers.map(function () {
      return $(this).data('value');
    }).get().join(', ');
    if (numbersValue) {
      $('.form-number .section-desc').text(`Kết quả không chứa số: ${numbersValue}`);
    }
    else {
      $('.form-number .section-desc').text(`Chứa tất cả các số`);
    }
  })
}

const suggestionPrice = () => {
  $('.suggestion-price .suggestion-price-item').click(function () {
    $('.suggestion-price .suggestion-price-item').removeClass('active');
    $(this).toggleClass('active');
    const price = $(this).data('value');
    const [min, max] = price.split('-');
    $('input[name="minPrice"]').val(min);
    $('input[name="maxPrice"]').val(max);
  })
}

const chooseProvince = () => {
  $('.g-options .g-option').click(function () {
    $(this).toggleClass('active');
  })
}

const clearProvince = () => {
  $('.btn-clear-province').click(function () {
    $('.g-option').removeClass('active');
  })
}

const showMoreProvince = () => {
  $('.btn-show-more').click(function () {
    const allOptions = $('.g-option');
    const visibleOptions = allOptions.not('.hidden');

    // Nếu đang trong trạng thái tìm kiếm
    if (currentSearchValue) {
      const filteredOptions = allOptions.filter(function () {
        return $(this).text().toLowerCase().includes(currentSearchValue.toLowerCase()) ||
          $(this).data('value').toLowerCase().includes(currentSearchValue.toLowerCase());
      });

      // Hiển thị thêm 8 kết quả tiếp theo
      const nextBatch = filteredOptions.filter(function () {
        return $(this).hasClass('hidden');
      }).slice(0, 8);

      nextBatch.removeClass('hidden');

      // Ẩn nút nếu không còn kết quả nào
      if (nextBatch.length < 8 || visibleOptions.length + nextBatch.length >= filteredOptions.length) {
        $(this).hide();
      }
    } else {
      // Nếu không trong trạng thái tìm kiếm
      const hiddenOptions = allOptions.filter('.hidden').slice(0, 8);
      hiddenOptions.removeClass('hidden');

      // Ẩn nút nếu không còn kết quả nào
      if (hiddenOptions.length < 8 || visibleOptions.length + hiddenOptions.length >= allOptions.length) {
        $(this).hide();
      }
    }
  });
}

const searchProvince = () => {
  $('.form-city .g-input input').on('input', function () {
    currentSearchValue = $(this).val(); // Cập nhật từ khóa tìm kiếm

    // Reset trạng thái ẩn/hiện của tất cả options
    $('.g-option').removeClass('hidden');
    $('.btn-show-more').show(); // Reset trạng thái nút xem thêm

    if (currentSearchValue) {
      const filteredOptions = $('.g-option').filter(function () {
        return $(this).text().toLowerCase().includes(currentSearchValue.toLowerCase()) ||
          $(this).data('value').toLowerCase().includes(currentSearchValue.toLowerCase());
      });

      // Ẩn tất cả options không khớp
      $('.g-option').not(filteredOptions).addClass('hidden');

      // Ẩn các options sau 8 kết quả đầu tiên
      filteredOptions.slice(8).addClass('hidden');

      // Hiển thị/ẩn nút "Xem thêm"
      if (filteredOptions.length > 8) {
        $('.btn-show-more').show();
      } else {
        $('.btn-show-more').hide();
      }
    } else {
      // Ẩn các options sau 8 kết quả đầu tiên khi không có từ khóa
      $('.g-option').slice(8).addClass('hidden');

      // Hiển thị/ẩn nút "Xem thêm"
      if ($('.g-option').length > 8) {
        $('.btn-show-more').show();
      } else {
        $('.btn-show-more').hide();
      }
    }
  });
}

module.exports = filterPlate;